import React, { useState, useEffect } from 'react';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';

// custom styles
import '../../App.css';
import ArticleCard from '../../components/ArticleCard';
import ArticleFooterCard from '../../components/ArticleFooterCard';

const ArticleOne = () => {
  // eslint-disable-next-line no-unused-vars
  const a = 1;
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const progressBarHandler = () => {
      const totalScroll = document.documentElement.scrollTop;
      // eslint-disable-next-line max-len
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll1 = `${totalScroll / windowHeight}`;

      setScroll(scroll1);
    };

    window.addEventListener('scroll', progressBarHandler);

    return () => window.removeEventListener('scroll', progressBarHandler);
  });

  return (
    <>
      <Navbar />
      <div className="md:px-28 px-5 md:py-16 py-10">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="md:text-4xl text-3xl font-medium uppercase font-trirong dark:text-white">WOMEN AND BUSINESS 2021</h1>
            <span className="block font-medium text-lpgreen text-sm capitalize pt-2">4 Mins. Read</span>
          </div>
        </div>
      </div>
      <div id="progressBarContainer">
        <div id="progressBar" style={{ transform: `scale(${scroll}, 1)`, opacity: `${scroll}` }} />
      </div>
      <section className="dark:bg-kiwi">
        <div className="md:px-28 px-5 md:py-40 py-16 relative">
          <div className="relative">
            <div className="bg-white dark:bg-black md:absolute bottom-0 md:left-0 md:px-16 px-5 py-10 md:py-16">
              <div className="flex justify-between py-1">
                <h1 className="text-lg text-orange uppercase font-medium tracking-widest">Article</h1>
              </div>
              <h1 className="md:text-4xl text-2xl font-trirong font-semibold pt-3 dark:text-white uppercase hover:text-orange">
                DRIVING ECONOMIC INCLUSION IN
                <br />
                THE INFORMAL SECTOR IN AFRICA
              </h1>
            </div>
            <img
              className="md:h-455px w-full object-cover"
              src="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620308499/blackboxlanding/Rectangle_25_nwkkuj.png"
              alt="people"
            />
          </div>
        </div>
      </section>
      <section>
        <div className="md:px-28 px-5 md:py-40">
          <div>
            <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="21" cy="20.5" rx="21" ry="20.5" fill="url(#paint0_angular)" />
              <defs>
                <radialGradient id="paint0_angular" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21 20.5) rotate(90) scale(20.5 21)">
                  <stop stopColor="#FF8300" />
                  <stop offset="1" stopColor="#E6D308" />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <div className="md:flex justify-between md:space-y-0 space-y-8 items-center pt-4">
            <div>
              <svg width="279" height="1" viewBox="0 0 279 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.309082" x2="279" y2="0.309082" stroke="#545454" strokeWidth="0.5" />
              </svg>
            </div>
            <div>
              <p className="text-orange">4 Mins. Read</p>
              <span className="pt-5 flex uppercase space-x-6 text-coregray tracking-widest items-center">
                <span className="dark:text-gray-300">FREE.</span>
                <span className="dark:text-gray-300">3 PAGES</span>
              </span>
            </div>
          </div>
          <div>
            <h1 className="text-4xl font-trirong py-4 capitalize dark:text-white">Introduction</h1>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Africa is the world’s second largest and second most populous continent, after Asia,
              accounting for more than 12% of the world’s human population.
              The continent is also blessed with youthful population,
              Africa has the youngest population in the world,
              with 70% of sub-Saharan African under the age of 30,
              and more than half of this population being women (50.12%).
              Consequently, the continent is largely blessed with natural
              and mineral resources which if put into proper use with creative know-how,
              African nations should be at the forefront of the Global Economic Index.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Despite the perceived potentials in Africa, the continent still remains the poorest
              and least developed continent in the world. Several factors including lack of basic
              amenities, poor education quality, lack of quality data and regressive government
              policy can be partly attributed to the perpetual position of Sub-Saharan Africa
              at the bottom of the Global Economy Index.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              This article seeks to examine women in the informal Africa economy,
              their potential and also driving economic inclusion. According to ILO,
              the informal economy refers to all economic activities by workers and
              economic units that are — in law or in practice — not covered or
              insufficiently covered by formal arrangements.
            </p>
            <div className="md:pt-24 md:pb-32 pt-10 pb-10">
              <img
                src="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620666541/blackboxlanding/Rectangle_59_usw2zb.png"
                className="w-full md:h-506px object-cover"
                alt="metrics"
              />
            </div>
            <h1 className="text-4xl font-trirong pt-4 pb-8 capitalize dark:text-altgrey">Potential of the Informal Sector</h1>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              The Africa Development Bank reported that the informal sector is the major source
              of employment across Africa, accounting for 80.8% of employment in Sub-Saharan Africa
              and 62 per cent in North Africa. The dynamism of the informal
              sector in creating employment
              and value addition is particularly strong, representing about
              80 per cent of the total labour
              force, and contributing about 55 per cent of sub-Saharan Africa’s GDP. The vibrancy of
              the informal sector is difficult to miss in African cities, street vendors are key in
              ensuring food security. Those who work in transport keep the city and the economy
              moving. And those operating in services are critical to the overall incomes and
              functioning of African cities.
              Furthermore, about 90% of the informal workers are women and youth,
              but the lack of social protection, skills’ upgrading and productive income often
              trap these groups into poverty and exclusion from economic growth and development,
              with only about 10 percent of operators benefiting from social protection schemes.
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              The urban informal economy is particularly common among youth (95.8% ages 15–24)
              and women (92.1%) and is an important contributor to poverty alleviation.
              Social protection like access to credit facilities, skills and digitization
              plays a key role for business owners and workers to build human capital,
              prevent the sale of productive assets in case of shocks, and promote savings
              to build resilience. Female informal cross-border retail trade,
              which is generally small and self-employed, amounted to 64 per cent of
              the added value of national trade in Benin, 46 per cent in Mali and 41
              per cent in Chad in 2012. In addition,
            </p>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              the diversity of informal employment across countries is captured by a set of
              characteristics related to the type and location of activities, access and use
              of technology, access to credit, productivity levels, and contribution
              to social security.
            </p>
            <div className="md:pt-24 md:pb-32 pt-10 pb-10">
              <img
                src="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620666527/blackboxlanding/Rectangle_60_aafwri.png"
                className="w-full md:h-506px object-cover"
                alt="metrics"
              />
            </div>
            <h1 className="md:text-4xl text-2xl font-trirong pt-4 pb-8 capitalize dark:text-altgrey">
              Informal Economy during the Covid-19 Pandemic
            </h1>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              Covid-19 lockdown adversely affected the informal sectors,
              with no access to social protection and inadequate savings
              to fall back on, the COVID-19 (coronavirus) pandemic lockdown
              made a lot of casual workers, hawkers and transport workers unable to work.
              This posed great threat to lives and properties of businesses and corporate
              entities as well as the vandalization of public infrastructures and facilities.
              A recent World Bank survey concluded that jobs in urban areas are particularly
              affected; during April-June 2020, 56.3% and 29.4% of urban respondents
              respectively in Nigeria and Uganda indicated that they stopped working
              because of COVID-19, against 39.2% and 11.1% in rural areas. Without assistance,
              many risk slipping into poverty. Also, living in informal settlements exposes
              them to increased health and social risks, further hindering their productivity.
            </p>
            <h1 className="md:text-4xl text-2xl font-trirong pt-4 md:pt-12 capitalize dark:text-white">
              Conclusion
            </h1>
            <p className="md:text-lg pt-6 dark:text-altgrey md:text-left text-justify">
              The sub-Saharan Africa youthful population has a great potential
              in driving creative and innovative solutions that will improve
              lives of Africans and also speed up economic development in the region.
              Government in these countries need to formulate relevant policies that
              will promote innovations and empower small businesses. Such empowerment
              should see innovations like Blackbox thrive and promoted.
            </p>
            <div className="bg-lightgrey dark:bg-kiwi mt-12 px-10 md:pb-20 pb-10 rounded-lg">
              <h1 className="md:text-4xl text-2xl font-trirong pt-4 md:pt-20 capitalize dark:text-white">
                References
              </h1>
              <div>
                <ul>
                  <li className="text-sm list-disc mt-5 dark:text-altgrey">
                    UNITED NATIONS ECONOMIC COMMISSION FOR AFRICA (ECA), Contribution
                    <br />
                    to the 2015 United Nations Economic
                    and Social Council (ECOSOC) Integration Segment, 2015.
                  </li>
                  <li className="text-sm list-disc mt-5 dark:text-altgrey">
                    MELIS GUVEN &RAPHAELA KARLEN, Supporting Africa’s urban informal sector:
                    <br />
                    Coordinated policies with social protection at the core, DECEMBER 03, 2020.
                  </li>
                  <li className="text-sm list-disc mt-5 dark:text-altgrey">PwC 2020 MSME Survey</li>
                  <li className="text-sm list-disc mt-5 dark:text-altgrey">FATE Foundation and Budgit MSME Survey 2021</li>
                  <li className="text-sm list-disc mt-5 dark:text-altgrey">
                    Augustin AO, 2018: The Crisis of Underdevelopment in Sub-Saharan Africa:
                    <br />
                    Multi-dimensional Perspectives; Journal of Political Sciences & Public Affairs
                  </li>
                </ul>
              </div>
            </div>
            <h1 className="text-4xl font-trirong pt-24 capitalize dark:text-white">
              The Author(s)
            </h1>
            <div className="pt-10 md:pb-0 pb-6">
              <svg width="59" height="1" viewBox="0 0 59 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="0.187109" x2="59" y2="0.187109" stroke="#61686C" strokeWidth="0.2" />
              </svg>
            </div>
            <div className="md:flex md:space-x-24 md:space-y-0 space-y-8 md:pb-0 pb-10 items-center md:pt-12">
              <ArticleFooterCard
                imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1618305464/blackboxlanding/IMG_3066_pusvlv.jpg"
                email="tobi@lawrencepriceltd.com"
              />
              <ArticleFooterCard
                name="Oluwafemi o."
                position="chief operation officer"
                imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620308452/blackboxlanding/Rectangle_02_okngo9.png"
                email="oluwafemi.omosuyi@lawrencepriceltd.com"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="md:flex items-center">
          <div className="md:w-1/2">
            <ArticleCard
              tag="Article"
              title="System Thinking..."
              link="/blog/article/2"
              imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620739656/blackboxlanding/Rectangle_45_spgp3k.png"
            />
          </div>
          <div className="md:w-1/2">
            <ArticleCard
              tag="Article"
              title=" Impact of Women"
              link="/blog/article/3"
              imageUrl="https://res.cloudinary.com/https-www-lawrencepriceltd-com/image/upload/v1620309377/blackboxlanding/Rectangle_001_pyug2n.png"
            />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ArticleOne;
